// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__LdPzQ","submit":"styles_submit__J9kWg"};